import React from 'react';
import SkillBadge from '../SkillBadge/SkillBadge';
import './SkillCategory.scss';

const SkillCategory = ({ title, skills }) => {
	return (
		<div className="skill-category">
			<h3 className="skill-category__title">{title}</h3>
			<div className="skill-category__skills">
				{skills.map((skill, index) => (
					<SkillBadge key={index} skill={skill} />
				))}
			</div>
		</div>
	);
};

export default SkillCategory;
